import React from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import { Accent } from 'components/TextBlock/TextBlock.styles';
import { Container, H1, Dek, InnerContainer, ButtonsContainer } from './IntrosSection.styles';

type IntrosSectionProps = {
  className?: string;
};

const IntrosSection = ({ className }: IntrosSectionProps): JSX.Element => (
  <Container className={className}>
    <InnerContainer>
      <H1 presentation="h2">
        <Accent>Team-Z</Accent> wedding advisors
      </H1>
      <Dek>
        We&apos;re here to offer support, encouragement, advice, and answer all your questions (big
        and small!) every day along the way.
      </Dek>
      <ButtonsContainer>
        <ButtonV3 component="a" size="large" href="mailto:advisor@zola.com">
          Send us an email
        </ButtonV3>
        <ButtonV3
          component="a"
          size="large"
          href="https://www.tiktok.com/@zola"
          target="_blank"
          rel="noopener noreferrer"
          textTransform={false}
          variant="secondary"
        >
          DM us on Tiktok
        </ButtonV3>
        <ButtonV3
          component="a"
          size="large"
          variant="secondary"
          href="https://www.instagram.com/zola/"
          target="_blank"
          rel="noopener noreferrer"
          textTransform={false}
        >
          Connect with us on IG
        </ButtonV3>
      </ButtonsContainer>
    </InnerContainer>
  </Container>
);

export default IntrosSection;
